import React from 'react';
import { ShowIf } from 'components/utils';
import {
  TrinhLanhDao,
  TrinhLanhDaoView,
  LanhDaoGiaoViec,
  LanhDaoGiaoViecView,
  TruongPhongGiaoViec,
  HuongXuLy,
  HuongXuLyView,
  KhongCoQuyTrinh,
  TuXuLy
} from './form-xu-ly';
import {
  TrinhLanhDaoTTXM,
  LanhDaoGiaoViecTTXM,
  NhapThongTinToTTXM,
  TrinhLanhDaoTTXMView,
  LanhDaoGiaoViecTTXMView,
  NhapThongTinToTTXMView,
  GiaiQuyetDonCanBo,
  KetQuaHoanThanhGiaiQuyetDonCanBo,
  CanBoGiaiQuyetYeuCauLapDuThao,
  LapDuThaoDonKhieuNaiCanBo,
  LapDuThaoCanBo,
  TrinhLanhDaoTheoDoiThucHien,
  TrinhLanhDaoTheoDoiThucHienView,
  LanhDaoGiaoViecTheoDoiGiamSat,
  LanhDaoGiaoViecTheoDoiGiamSatView,
  CanBoNhanYeuCauTheoDoiThucHien
} from './form-giai-quyet';
import {
  KetQuaLapDuThaoCanBo,
  // KetQuaLapDuThaoDonKhieuNaiCanBo,
  KetQuaCanBoGiaiQuyetYeuCauLapDuThao,
  KetQuaTheoDoiThucHien,
} from 'modules/giai-quyet-don/subView';
import {
  TrinhLanhDaoKTDX,
  TrinhLanhDaoKTDXView,
  LanhDaoGiaoViecKTDX,
  LanhDaoGiaoViecKTDXView,
  CanBoKiemTraDeXuatView,
  CanBoKiemTraDeXuat
} from './form-kiem-tra-de-xuat';
import {
  DinhChiView
} from './form-dinh-chi';

import { validatable } from 'components/utils';

let classNames = require('classnames');

class FormXuLyHoacGiaiQuyet extends React.Component {
  onChange(state, isInit) {
    if (this.props.processType === 'XU_LY_DON' || this.props.alias === 'XuLyDonTuXuLy') {
      state.don = {
        id: Number(this.props.donId)
      };
    }
    if (isInit) {
      this.props.onInit(state);
    } else {
      this.props.onChange(state);
    }
  }

  onChangeTepDinhKem(tepDinhKem, deleteTepDinhKem, loaiQuyTrinh, loaiTepDinhKem) {

    this.props.onChangeTepDinhKem(tepDinhKem, deleteTepDinhKem, loaiQuyTrinh, loaiTepDinhKem);
  }

  getState(listNextStates, type) {

    let stateId = null;

    listNextStates.map((item, i) => {

      if (item.type == type) {

        stateId = item.stateId;
        return stateId;
      }
    })
    return stateId;
  }

  viewComponent() {
    if (this.props.trangThaiDonDonVi.ketQuaType != 'DINH_CHI') {
      switch (this.props.alias) {
        case 'WordProcessingOperatorAction':
          if (this.props.donDangXuLy) {
            return (
              <TrinhLanhDao
                donId={this.props.donId}
                thongTinDon={this.props.thongTinDon}
                onChange={this.onChange.bind(this)}
                thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                donInfo = {this.props.donInfo}
                listNextStates={this.props.listNextStates}
                getState={this.getState.bind(this)}
                listTaiLieuVanThu={this.props.listTaiLieuVanThu}
                thongTinXuLyGiaiQuyet={this.props.thongTinXuLyGiaiQuyet}
                bindValidator={this}
                data = {this.props.data} />
            )
          } else {
            return (
              <TrinhLanhDaoView
                thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                donInfo = {this.props.donInfo}
                thongTinXuLyGiaiQuyet={this.props.thongTinXuLyGiaiQuyet}
                listTaiLieuVanThu={this.props.listTaiLieuVanThu}
                listTaiLieuVanThuChuyenDonBoSungHoSo={this.props.listTaiLieuVanThuChuyenDonBoSungHoSo}
              />
            )
          }

        case 'TruongPhongTDTHAction':
        case 'CanBoTDTHAction':
          if (this.props.donDangXuLy) {
            return (
              <div className='container-filedinhkem'>
                <CanBoNhanYeuCauTheoDoiThucHien
                  id={this.props.donId}
                  tuGiaiQuyet={true}
                  thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                  donInfo = {this.props.donInfo}
                  thongTinGiaiQuyetDonId={this.props.thongTinGiaiQuyetDonId}
                  listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
                  dataNextStates={this.props.listNextStates}
                  loaiDon={this.props.loaiDonGiaTri}
                  />
              </div>
            )
          } else {
            return (
              <div className='container-filedinhkem'>
                <KetQuaTheoDoiThucHien
                  listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
                  loaiDon={this.props.loaiDonGiaTri}
                  thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                  donInfo = {this.props.donInfo}
                  lanhDaoView={true}
                  {...this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                  listTaiLieuVanThuBoSungHoSo={this.props.listTaiLieuVanThuBoSungHoSo} />
              </div>
            )
          }

        case 'canBoTDTHKhongQuyTrinh':
          if (this.props.donDangXuLy) {
            return (
              <CanBoNhanYeuCauTheoDoiThucHien
                id={this.props.donId}
                thongTinGiaiQuyetDonId={this.props.thongTinGiaiQuyetDonId}
                listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
                dataNextStates={this.props.listNextStates}
                thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                donInfo = {this.props.donInfo}
                loaiDon={this.props.loaiDonGiaTri}
                />
            )
          } else {
            return (
              <div className='container-filedinhkem'>
                <KetQuaTheoDoiThucHien
                  listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
                  loaiDon={this.props.loaiDonGiaTri}
                  thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                  donInfo = {this.props.donInfo}
                  lanhDaoView={true}
                  {...this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                  listTaiLieuVanThuBoSungHoSo={this.props.listTaiLieuVanThuBoSungHoSo} />
              </div>
            )
          }

        case 'LanhDaoTDTHAction':
          if (this.props.donDangXuLy) {
            return (
              <LanhDaoGiaoViecTheoDoiGiamSat
                id={this.props.donId}
                thongTinGiaiQuyetDonId={this.props.thongTinGiaiQuyetDonId}
                listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
                dataNextStates={this.props.listNextStates}
                thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                donInfo = {this.props.donInfo}
                loaiDon={this.props.loaiDonGiaTri}
                />
            )
          } else {
            return (
              <LanhDaoGiaoViecTheoDoiGiamSatView
                listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
                loaiDon={this.props.loaiDonGiaTri}
                thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                donInfo = {this.props.donInfo}
                thongTinXuLyGiaiQuyet={this.props.thongTinXuLyGiaiQuyet} />
            )
          }

        case 'CanBoNhapLieuTDTHAction':
          if (this.props.donDangXuLy) {
            return (
              <TrinhLanhDaoTheoDoiThucHien
                id={this.props.donId}
                thongTinGiaiQuyetDonId={this.props.thongTinGiaiQuyetDonId}
                listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
                dataNextStates={this.props.listNextStates}
                thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                donInfo = {this.props.donInfo}
                loaiDon={this.props.loaiDonGiaTri}
                />
            )
          } else {
            return (
              <TrinhLanhDaoTheoDoiThucHienView
                listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
                loaiDon={this.props.loaiDonGiaTri}
                thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                donInfo = {this.props.donInfo}
                thongTinXuLyGiaiQuyet={this.props.thongTinXuLyGiaiQuyet} />
            )
          }

        case 'ManagerAction':
          if (this.props.donDangXuLy) {
            return (
              <LanhDaoGiaoViec
                donId={this.props.donId}
                loaiDonGiaTri={this.props.loaiDonGiaTri}
                onChange={this.onChange.bind(this)}
                listNextStates={this.props.listNextStates}
                getState={this.getState.bind(this)}
                thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                donInfo = {this.props.donInfo}
                listTaiLieuVanThu={this.props.listTaiLieuVanThu}
                thongTinXuLyGiaiQuyet={this.props.thongTinXuLyGiaiQuyet}
                bindValidator={this} />
            )
          } else {
            return (
              <LanhDaoGiaoViecView
                thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                donInfo = {this.props.donInfo}
                thongTinXuLyGiaiQuyet={this.props.thongTinXuLyGiaiQuyet} />
            )
          }

        case 'LeaderAction':
          if (this.props.donDangXuLy) {
            return (
              <TruongPhongGiaoViec
                ngayNhanDon={this.props.data.ngayNhanDon}
                ngayTraTTXMKhongDungThamQuyen={this.props.data.ngayTraTTXMKhongDungThamQuyen}
                donId={this.props.donId}
                onChange={this.onChange.bind(this)}
                listNextStates={this.props.listNextStates}
                getState={this.getState.bind(this)}
                thongTinXuLyGiaiQuyet={this.props.thongTinXuLyGiaiQuyet}
                bindValidator={this}
                thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                donInfo = {this.props.donInfo}
                truongPhongThuHoi={this.props.thuHoi}
                loaiDonGiaTri={this.props.loaiDonGiaTri}
                onSave={this.props.onSave}
                inPhieu={this.props.inPhieu.bind(this)}
                listTaiLieuVanThu={this.props.listTaiLieuVanThu}
                onChangeTepDinhKem={this.onChangeTepDinhKem.bind(this)}
              />
            )
          } else {
            return (
              <HuongXuLyView
                loaiDonGiaTri={this.props.loaiDonGiaTri}
                thongTinXuLyGiaiQuyet={this.props.thongTinXuLyGiaiQuyet}
                inPhieu={this.props.inPhieu.bind(this)}
                thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                donInfo = {this.props.donInfo}
                listTaiLieuVanThu={this.props.listTaiLieuVanThu}/>
            )
          }

        case 'WordProcessingSpecialistAction':
          if (this.props.donDangXuLy) {
            return (
              <HuongXuLy
                loaiDonGiaTri={this.props.loaiDonGiaTri}
                donId={this.props.donId}
                onSave={this.props.onSave}
                onChange={this.onChange.bind(this)}
                listNextStates={this.props.listNextStates}
                getState={this.getState.bind(this)}
                thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                donInfo = {this.props.donInfo}
                ngayNhanDon={this.props.data.ngayNhanDon}
                ngayTraTTXMKhongDungThamQuyen={this.props.data.ngayTraTTXMKhongDungThamQuyen}
                thongTinXuLyGiaiQuyet={this.props.thongTinXuLyGiaiQuyet}
                inPhieu={this.props.inPhieu.bind(this)}
                bindValidator={this}
                listTaiLieuVanThu={this.props.listTaiLieuVanThu}
                onChangeTepDinhKem={this.onChangeTepDinhKem.bind(this)} />
            )
          } else {
            return (
              <HuongXuLyView
                loaiDonGiaTri={this.props.loaiDonGiaTri}
                thongTinXuLyGiaiQuyet={this.props.thongTinXuLyGiaiQuyet}
                inPhieu={this.props.inPhieu.bind(this)}
                thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                donInfo = {this.props.donInfo}
                listTaiLieuVanThu={this.props.listTaiLieuVanThu}/>
            )
          }

        case 'WordProcessingSpecialistActionNoProcess':
          if (this.props.donDangXuLy) {
            return (
              <KhongCoQuyTrinh
                checkValidate = {this.props.checkValidate}
                thongTinDon={this.props.thongTinDon}
                loaiDonGiaTri={this.props.loaiDonGiaTri}
                donId={this.props.donId}
                tongSoLuotTCD={this.props.tongSoLuotTCD}
                onChange={this.onChange.bind(this)}
                ngayNhanDon={this.props.data.ngayNhanDon}
                ngayTraTTXMKhongDungThamQuyen={this.props.data.ngayTraTTXMKhongDungThamQuyen}
                listNextStates={this.props.listNextStates}
                getState={this.getState.bind(this)}
                thongTinXuLyGiaiQuyet={this.props.thongTinXuLyGiaiQuyet}
                inPhieu={this.props.inPhieu.bind(this)}
                bindValidator={this}
                thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                donInfo = {this.props.donInfo}
                onSave={this.props.onSave}
                listTaiLieuVanThu={this.props.listTaiLieuVanThu}
                onChangeTepDinhKem={this.onChangeTepDinhKem.bind(this)}
                action={this.props.action} />
            )
          } else {
            return (
              <HuongXuLyView
                loaiDonGiaTri={this.props.loaiDonGiaTri}
                thongTinXuLyGiaiQuyet={this.props.thongTinXuLyGiaiQuyet}
                inPhieu={this.props.inPhieu.bind(this)}
                thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                donInfo = {this.props.donInfo}
                listTaiLieuVanThu={this.props.listTaiLieuVanThu}/>
            )
          }

        case 'CanBoGiaiQuyetDonKhongQuyTrinh':
          if (this.props.donDangXuLy) {
            return (
              <GiaiQuyetDonCanBo
                donId={this.props.donId}
                onSave={this.props.onSave}
                thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                donInfo = {this.props.donInfo}
                listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDon}
                listTaiLieuVanThuGiaiQuyetDonView={this.props.listTaiLieuVanThuGiaiQuyetDonView}
                listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM={this.props.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM}
                listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ={this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ}
                listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra={this.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra}
                listTaiLieuVanThuGiaiQuyetDonGiaHanGQ={this.props.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ}
                loaiDonGiaTri={this.props.loaiDonGiaTri}
                listNextStates={this.props.listNextStates}
                thongTinGiaiQuyetDonId = {this.props.thongTinGiaiQuyetDonId}
                {...this.props.data}
              />
            )
          } else {
              return (
                <KetQuaHoanThanhGiaiQuyetDonCanBo
                  loaiDon={this.props.loaiDonGiaTri}
                  thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                  donInfo = {this.props.donInfo}
                  listTaiLieuVanThuBoSungHoSo = {this.props.listTaiLieuVanThuBoSungHoSo}
                  {...this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                  listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDonView}
                />
              )
          }

        case 'CanBoNhapLieuTTXMAction':
          if (this.props.donDangXuLy) {
            return (
              <TrinhLanhDaoTTXM
                donId={this.props.donId}
                onChange={this.onChange.bind(this)}
                listNextStates={this.props.listNextStates}
                getState={this.getState.bind(this)}
                thongTinXuLyGiaiQuyet={this.props.thongTinXuLyGiaiQuyet}
                thongTinGiaiQuyetDonId={this.props.thongTinGiaiQuyetDonId}
                listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDon}
                loaiDonGiaTri={this.props.loaiDonGiaTri}
                bindValidator={this}
                thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                donInfo = {this.props.donInfo}
                onSave={this.props.onSave}
                onChangeTepDinhKem={this.onChangeTepDinhKem.bind(this)} />
            )
          } else {
            return (
              <TrinhLanhDaoTTXMView
                thongTinXuLyGiaiQuyet={this.props.thongTinXuLyGiaiQuyet}
                thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                donInfo = {this.props.donInfo}
                listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDon}
              />
            )
          }

        case 'LanhDaoTTXMAction':
          if (this.props.donDangXuLy) {
            return (
              <LanhDaoGiaoViecTTXM
                donId={this.props.donId}
                onChange={this.onChange.bind(this)}
                listNextStates={this.props.listNextStates}
                getState={this.getState.bind(this)}
                thongTinXuLyGiaiQuyet={this.props.thongTinXuLyGiaiQuyet}
                thongTinGiaiQuyetDonId={this.props.thongTinGiaiQuyetDonId}
                listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDon}
                loaiDonGiaTri={this.props.loaiDonGiaTri}
                bindValidator={this}
                thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                donInfo = {this.props.donInfo}
                onChangeTepDinhKem={this.onChangeTepDinhKem.bind(this)} />
            )
          } else {
            return (
              <LanhDaoGiaoViecTTXMView
                thongTinXuLyGiaiQuyet={this.props.thongTinXuLyGiaiQuyet}
                listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDon}
                thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                donInfo={this.props.donInfo}
                thongTinGiaiQuyetDonPlus={this.props.thongTinGiaiQuyetDonPlus}/>
            )
          }

        case 'CanBoTTXMKhongQuyTrinh':
        case 'TruongPhongTTXMAction' : 
          if (this.props.donDangXuLy) {
            return (
              <NhapThongTinToTTXM
                id={this.props.donId}
                dataNextStates={this.props.listNextStates}
                listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM}
                thongTinGiaiQuyetDonId={this.props.thongTinGiaiQuyetDonId}
                thongTinGQD={this.props.thongTinXuLyGiaiQuyet && this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo ? this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo : ''}
                donInfo={this.props.donInfo}
                loaiDon={this.props.loaiDonGiaTri}
                alias={this.props.alias}
              />
            );
          } else {
            const thongTinGiaiQuyetDonInfo = this.props.thongTinXuLyGiaiQuyet && this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo;
            return (
              <NhapThongTinToTTXMView
                {...thongTinGiaiQuyetDonInfo}
                thongTinGiaiQuyetDonPlus = {this.props.thongTinGiaiQuyetDonPlus}
                thongTinXuLyGiaiQuyet={this.props.thongTinXuLyGiaiQuyet}
                thongTinGiaiQuyetDonId={this.props.thongTinGiaiQuyetDonId}
                thongTinGQD={this.props.thongTinXuLyGiaiQuyet && this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo ? this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo : ''}
                donInfo={this.props.donInfo}
                listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
                loaiDonGiaTri={this.props.loaiDonGiaTri}
              />
            );
          }
        case 'CanBoTTXMAction' :
          if (this.props.donDangXuLy) {
            return (
              <NhapThongTinToTTXM
                id={this.props.donId}
                dataNextStates={this.props.listNextStates}
                listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM}
                thongTinGiaiQuyetDonId={this.props.thongTinGiaiQuyetDonId}
                thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                donInfo = {this.props.donInfo}
                loaiDon={this.props.loaiDonGiaTri}
                alias={this.props.alias}
              />
            )
          } else {
            return (
              <NhapThongTinToTTXMView
                {...this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                thongTinGiaiQuyetDonPlus = {this.props.thongTinGiaiQuyetDonPlus}
                thongTinXuLyGiaiQuyet={this.props.thongTinXuLyGiaiQuyet}
                thongTinGiaiQuyetDonId={this.props.thongTinGiaiQuyetDonId}
                thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                donInfo = {this.props.donInfo}
                listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
                loaiDonGiaTri={this.props.loaiDonGiaTri}
              />
            )
          }

        case 'CanBoGiaiQuyetDonAction':
          return (
            <KetQuaHoanThanhGiaiQuyetDonCanBo
              loaiDon={this.props.loaiDonGiaTri}
              listTaiLieuVanThuBoSungHoSo = {this.props.listTaiLieuVanThuBoSungHoSo}
              {...this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
              thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
              donInfo = {this.props.donInfo}
              listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDonView}
              lanhDaoView = {true}
            />
          )
        case 'TruongPhongNhanBaoCaoTTXMVaGiaoViec':
        case 'CanBoGiaiQuyetDonLapDuThaoAction':
        case 'TruongPhongNhanDuThaoVaGiaoViec':
        case 'CanBoGiaiQuyetDonXuLySauKhiNhanDuThaoAction':
          // if (this.props.loaiDonGiaTri === 'DON_KHIEU_NAI') {
          //   return (
          //     <div className='container-filedinhkem'>
          //       <KetQuaLapDuThaoDonKhieuNaiCanBo
          //         listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
          //         {...this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
          //         loaiDon={this.props.loaiDonGiaTri}
          //         thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
          //         donInfo = {this.props.donInfo}
          //         lanhDaoView={true}
          //       />
          //     </div>
          //   )

          // } else {
          return (
            <div className='container-filedinhkem'>
              <KetQuaLapDuThaoCanBo
                listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
                {...this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                loaiDon={this.props.loaiDonGiaTri}
                donInfo = {this.props.donInfo}
                thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                listTaiLieuVanThuBoSungHoSo = {this.props.listTaiLieuVanThuBoSungHoSo}
                lanhDaoView={true}
              />
            </div>
          )
          // }
        case 'TruongPhongTTXMNhanYeuCauVaGiaoViecAction':
        case 'CanBoTTXMChuyenDuThaoAction':
          return (
            <div className='container-filedinhkem'>
              <KetQuaCanBoGiaiQuyetYeuCauLapDuThao
                {...this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
                loaiDon={this.props.loaiDonGiaTri}
                thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                donInfo = {this.props.donInfo}
                lanhDaoView={true}
              />
            </div>
          )

        case 'vanThuKiemTraDeXuat':
          if (this.props.donDangXuLy) {
            return (
              <TrinhLanhDaoKTDX
                donId={this.props.donId}
                onChange={this.onChange.bind(this)}
                listNextStates={this.props.listNextStates}
                getState={this.getState.bind(this)}
                thongTinXuLyGiaiQuyet={this.props.thongTinXuLyGiaiQuyet}
                thongTinGiaiQuyetDonId={this.props.thongTinGiaiQuyetDonId}
                listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDon}
                loaiDonGiaTri={this.props.loaiDonGiaTri}
                bindValidator={this}
                thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                donInfo = {this.props.donInfo}
                onChangeTepDinhKem={this.onChangeTepDinhKem.bind(this)} />
            )
          } else {
            return (
              <TrinhLanhDaoKTDXView
                thongTinXuLyGiaiQuyet={this.props.thongTinXuLyGiaiQuyet}
                thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                donInfo = {this.props.donInfo}
                listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDon} />
            )
          }

        case 'lanhDaoKiemTraDeXuat':
          if (this.props.donDangXuLy) {
            return (
              <LanhDaoGiaoViecKTDX
                donId={this.props.donId}
                onChange={this.onChange.bind(this)}
                listNextStates={this.props.listNextStates}
                getState={this.getState.bind(this)}
                thongTinXuLyGiaiQuyet={this.props.thongTinXuLyGiaiQuyet}
                thongTinGiaiQuyetDonId={this.props.thongTinGiaiQuyetDonId}
                listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDon}
                loaiDonGiaTri={this.props.loaiDonGiaTri}
                bindValidator={this}
                thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                donInfo = {this.props.donInfo}
                onChangeTepDinhKem={this.onChangeTepDinhKem.bind(this)} />
            )
          } else {
            return (
              <LanhDaoGiaoViecKTDXView
                thongTinXuLyGiaiQuyet={this.props.thongTinXuLyGiaiQuyet}
                thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                donInfo = {this.props.donInfo}
                listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDon} />
            )
          }

        case 'canBoKiemTraDeXuat':
          return (
            <CanBoKiemTraDeXuatView
              thongTinXuLyGiaiQuyet={this.props.thongTinXuLyGiaiQuyet}
              {...this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
              thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
              donInfo = {this.props.donInfo}
              listTaiLieuVanThuKiemTraDeXuat={this.props.listTaiLieuVanThuKiemTraDeXuat}
              listTaiLieuVanThuBoSungHoSo = {this.props.listTaiLieuVanThuBoSungHoSo}
            />
          )

        case 'canBoKiemTraDeXuatKhongQuyTrinh':
          if (this.props.donDangXuLy) {
            return (
              <CanBoKiemTraDeXuat
                donId={this.props.donId}
                thongTinYeuCauKiemTraDeXuat={this.props.thongTinYeuCauKiemTraDeXuat}
                listTaiLieuVanThuKiemTraDeXuat={this.props.listTaiLieuVanThuKiemTraDeXuat}
                loaiDonGiaTri={this.props.loaiDonGiaTri}
                listNextStates={this.props.listNextStates}
                thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                donInfo = {this.props.donInfo}
                onSave={this.props.onSave}
                thongTinGiaiQuyetDonId = {this.props.thongTinGiaiQuyetDonId}
                {...this.props.data}/>
            )
          } else {
            return (
              <CanBoKiemTraDeXuatView
                thongTinXuLyGiaiQuyet={this.props.thongTinXuLyGiaiQuyet}
                {...this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                donInfo = {this.props.donInfo}
                listTaiLieuVanThuKiemTraDeXuat={this.props.listTaiLieuVanThuKiemTraDeXuat}
                listTaiLieuVanThuBoSungHoSo = {this.props.listTaiLieuVanThuBoSungHoSo}
              />
            )
          }

        case 'CanBoTTXMChuyenDuThaoKhongQuyTrinh':
          if (this.props.donDangXuLy) {
            return (
              <div className='container-filedinhkem'>
                <CanBoGiaiQuyetYeuCauLapDuThao
                id={this.props.donId}
                thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                donInfo = {this.props.donInfo}
                dataNextStates={this.props.listNextStates}
                listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
                thongTinGiaiQuyetDonId={this.props.thongTinGiaiQuyetDonId}
                lanhDaoView={true}
                loaiDon={this.props.loaiDonGiaTri}/>
              </div>
            )
          } else {
            return (
              <div className='container-filedinhkem'>
                <KetQuaCanBoGiaiQuyetYeuCauLapDuThao
                {...this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                donInfo = {this.props.donInfo}
                listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
                loaiDon={this.props.loaiDonGiaTri}
                lanhDaoView={true}/>
              </div>
            )
          }
        case 'CanBoGiaiQuyetDonLapDuThaoKhongQuyTrinh':
          if (this.props.donDangXuLy) {
            if (this.props.loaiDonGiaTri === 'DON_KHIEU_NAI') {

              return (
                <div className='container-filedinhkem'>
                  <LapDuThaoDonKhieuNaiCanBo
                  id={this.props.donId}
                  dataNextStates={this.props.listNextStates}
                  thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                  donInfo = {this.props.donInfo}
                  listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM}
                  listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM={this.props.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM}
                  listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ={this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ}
                  listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra={this.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra}
                  listTaiLieuVanThuGiaiQuyetDonGiaHanGQ={this.props.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ}
                  thongTinGiaiQuyetDonId={this.props.thongTinGiaiQuyetDonId}
                  loaiDon={this.props.loaiDonGiaTri}/>
                </div>
              )
            } else {
              return (
                <div className='container-filedinhkem'>
                  <LapDuThaoCanBo
                  id={this.props.donId}
                  thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                  donInfo = {this.props.donInfo}
                  dataNextStates={this.props.listNextStates}
                  listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM}
                  listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM={this.props.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM}
                  listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ={this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ}
                  listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra={this.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra}
                  listTaiLieuVanThuGiaiQuyetDonGiaHanGQ={this.props.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ}
                  thongTinGiaiQuyetDonId={this.props.thongTinGiaiQuyetDonId}
                  loaiDon={this.props.loaiDonGiaTri}/>
                </div>
              )
            }
          // } else if (this.props.loaiDonGiaTri === 'DON_KHIEU_NAI') {
          //   return (
          //     <div className='container-filedinhkem'>
          //       <KetQuaLapDuThaoDonKhieuNaiCanBo
          //         listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
          //         {...this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
          //         loaiDon={this.props.loaiDonGiaTri}
          //         thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
          //         donInfo = {this.props.donInfo}
          //         listTaiLieuVanThuBoSungHoSo = {this.props.listTaiLieuVanThuBoSungHoSo}
          //         lanhDaoView={true}
          //         />
          //       </div>
          //   )
          } else {
            return (
              <div className='container-filedinhkem'>
                <KetQuaLapDuThaoCanBo
                  listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
                  {...this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                  loaiDon={this.props.loaiDonGiaTri}
                  thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                  donInfo = {this.props.donInfo}
                  listTaiLieuVanThuBoSungHoSo = {this.props.listTaiLieuVanThuBoSungHoSo}
                  lanhDaoView={true}
                  />
              </div>
            )
          }

        case 'CanBoGiaiQuyetDonXuLySauKhiNhanDuThaoKhongQuyTrinh':
          if (this.props.donDangXuLy) {
            return (
              <div className='container-filedinhkem'>
                <LapDuThaoDonKhieuNaiCanBo
                  id={this.props.donId}
                  nhanDuThao={true}
                  thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                  donInfo = {this.props.donInfo}
                  dataNextStates={this.props.listNextStates}
                  listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM}
                  listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM={this.props.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM}
                  listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ={this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ}
                  listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra={this.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra}
                  listTaiLieuVanThuGiaiQuyetDonGiaHanGQ={this.props.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ}
                  thongTinGiaiQuyetDonId={this.props.thongTinGiaiQuyetDonId}
                  loaiDon={this.props.loaiDonGiaTri}/>
              </div>
            )
          } else {
            return (
              <div className='container-filedinhkem'>
                <KetQuaLapDuThaoCanBo
                  nhanDuThao={true}
                  listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
                  {...this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                  loaiDon={this.props.loaiDonGiaTri}
                  thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
                  donInfo = {this.props.donInfo}
                  listTaiLieuVanThuBoSungHoSo = {this.props.listTaiLieuVanThuBoSungHoSo}
                  lanhDaoView={true}
                  />
              </div>
            )
          }

        // Tu xu ly
        case 'XuLyDonTuXuLy':
          return (
            <TuXuLy
            loaiDonGiaTri={this.props.loaiDonGiaTri}
            ngayNhanDon={this.props.data.ngayNhanDon}
            ngayTraTTXMKhongDungThamQuyen={this.props.data.ngayTraTTXMKhongDungThamQuyen}
            donId={this.props.donId}
            onSave={this.props.onSave}
            onChange={this.onChange.bind(this)}
            listNextStates={this.props.listNextStates}
            getState={this.getState.bind(this)}
            thongTinXuLyGiaiQuyet={this.props.thongTinXuLyGiaiQuyet}
            inPhieu={this.props.inPhieu.bind(this)}
            bindValidator={this}
            listTaiLieuVanThu={this.props.listTaiLieuVanThu}
            onChangeTepDinhKem={this.onChangeTepDinhKem.bind(this)} />
          )
        default: break;
      }
    } else {
      return (
        <DinhChiView
          donId={this.props.donId}
          lyDoDinhChi={this.props.lyDoDinhChi}
          processType={this.props.processType}
          thongTinGQD={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo}
          donInfo = {this.props.donInfo}
          listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM}
          listTaiLieuVanThu={this.props.listTaiLieuVanThu}
          ma = {this.props.ma}/>
      )
    }
  }

  render() {
    let classes = ['box-items', 'mb0-18'];
    let classBox = ['group-box'];

    if (this.props.pageType === "THEM_MOI_VA_CHINH_SUA_DON") {
      classBox.push('pl5');
      classBox.push('pr5');
      classBox.push('mt20');
    }

    let inputClasses = classNames(classes);
    let boxClasses = classNames(classBox);
    let { alias } = this.props;
    let viewGQD = false;
    let showTitle = true;
    if (
      alias == 'CanBoGiaiQuyetDonLapDuThaoAction' ||
      alias == 'CanBoGiaiQuyetDonXuLySauKhiNhanDuThaoAction' ||
      alias == 'CanBoTTXMChuyenDuThaoAction' ||
      alias == 'CanBoNhapLieuTDTHAction' ||
      alias == 'LanhDaoTDTHAction' ||
      alias == 'CanBoTDTHAction' ||
      alias == 'canBoTDTHKhongQuyTrinh' ||
      alias == 'CanBoGiaiQuyetDonAction'
    ) {
      viewGQD = true;
    }
    if (
      alias == 'CanBoTTXMKhongQuyTrinh' ||
      alias == 'CanBoTTXMAction' ||
      alias == 'CanBoTDTHAction' ||
      alias == 'canBoTDTHKhongQuyTrinh' ||
      alias == 'CanBoNhapLieuTDTHAction' ||
      alias == 'LanhDaoTDTHAction' ||
      alias == 'TruongPhongTDTHAction' ||
      alias == 'CanBoTTXMChuyenDuThaoKhongQuyTrinh' ||
      alias == 'CanBoGiaiQuyetDonLapDuThaoKhongQuyTrinh' ||
      alias == 'CanBoGiaiQuyetDonXuLySauKhiNhanDuThaoKhongQuyTrinh'
    ) {
      showTitle = false;
    }
    return (
      <div>
        <ShowIf condition={!viewGQD}>
          <div>
            <div className={inputClasses}>
              <div className="box-forward">
                <div className="container-box">
                  <div className={boxClasses}>
                    {showTitle &&
                      <div className="title">
                        <div className="row pl15 pr15">
                          <h3>{this.props.title}</h3>
                        </div>
                      </div>
                    }
                    {this.viewComponent()}
                  </div>
                </div>
              </div>
            </div>
            </div>
        </ShowIf>
        <ShowIf condition={viewGQD}>
          <div className='container-filedinhkem'>{this.viewComponent()}</div>
        </ShowIf>
      </div>
    )
  }
}

FormXuLyHoacGiaiQuyet.defaultProps = {
  title: 'Thông tin xử lý',
  alias: 'WordProcessingOperatorAction',
  donId: 0,
  onInit: function () {},
  inPhieu: function () {},
  onSave: false,
  data: {},
  donInfo: {}
}

export default validatable(FormXuLyHoacGiaiQuyet);





// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/xu-ly-don/FormXuLyHoacGiaiQuyet.jsx